import { render, staticRenderFns } from "./Excel2BP.vue?vue&type=template&id=9bd18268"
import script from "./Excel2BP.vue?vue&type=script&lang=js"
export * from "./Excel2BP.vue?vue&type=script&lang=js"
import style0 from "./Excel2BP.vue?vue&type=style&index=0&id=9bd18268&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports